import "./Home.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import IlluminatingFaithForTheYouth from "./sections/IlluminatingFaithForTheYouth";
import OurSignatureSolutions from "./sections/OurSignatureSolutions";
import EducationalPhilosophy from "./sections/EducationalPhilosophy";
import LatestFromTheOven from "./sections/LatestFromTheOven";
import VamosExpandirSeusNegocios from "./sections/VamosExpandirSeusNegocios";
import IndexSeverityScale from "./sections/IndexSeverityScale";
import InformativeFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <FraternalExcellenceHeader />
      <IlluminatingFaithForTheYouth />
      <OurSignatureSolutions />
      <EducationalPhilosophy />
      <LatestFromTheOven />
      <VamosExpandirSeusNegocios />
      <IndexSeverityScale />
      <InformativeFooter />
    </div>;
}